import { withViewModel } from '@hooks/useViewModel';
import RHFCitySelect from './RHFCitySelect';
import useRHFCitySelect from './useRHFCitySelect';

const CitySelectContainer = withViewModel(RHFCitySelect, useRHFCitySelect);

export default CitySelectContainer;
